import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import { Button, message } from "antd";
import { post } from "../../../services/request";
import { DING_USER_SYNC } from "../../../services/request/urls";

const UserSyncButton: React.FC = (props) => {
  const [loading, setLoading] = useState(false);

  // useEffect(() => {}, [])
  const updateDingUser = async () => {
    if (loading) return;
    setLoading(true);

    const res = await post(DING_USER_SYNC, null, true);

    if (res?.code === 1) {
      message.success("同步成功");
    } else {
      message.error("同步失败");
    }

    setLoading(false);
  };

  return (
    <Button type="primary" loading={loading} onClick={updateDingUser}>
      同步钉钉用户信息
    </Button>
  );
};

export default UserSyncButton;
